export default "/images/developer-options.svg?5c7ecb532e9169364b677bcd58378086";